import React from 'react';
import "@fontsource/titillium-web"; 
import genStyles from './generale.module.css';
import GeocoderInterface from './geocoderInterface';
import { useRecoilState, useRecoilValue } from 'recoil';
import { entiteFileState, loadingState, showResultFormState } from '../atoms/GeocoderState';
import GeocoderResult from './geocoderResult';
import LoadingForm from './utilsForm/loadingForm';

export default function GeocoderForm({ 
  api_collection, 
  api_pci, 
  ban_uri,
  user_data, 
  fileTypesLinks,
  iddCollectionSelected,
  containerId,
  embedded,
  onValidateEntite,
  onReloaEntite 
}) {    
  
  const [showResultForm, setActiveTab] = useRecoilState(showResultFormState);
  const loading = useRecoilValue(loadingState);
  const entitesFile = useRecoilValue(entiteFileState);

    return (
        <div className={`${genStyles.familyFont} ${genStyles.fontSize16} ${genStyles.bodygcd}`}>
          {!embedded && 
          <div className="mb20 mt10">
            <div className={`${genStyles.tabsCtn}`}>
                <a onClick={(e)=>{ e.preventDefault(); setActiveTab(false); }}
                    className={`cursor-pointer ${genStyles.tabBtn} ${!showResultForm ? genStyles.tabBtnActive : genStyles.tabBtnInactive}`}>
                    <i className={`fa-regular fa-file-import ${genStyles.icomargin}`}></i>
                    GEOCODEUR
                </a>
              {entitesFile.length > 0 &&
                <a onClick={(e)=>{ e.preventDefault(); setActiveTab(true); }}
                    className={`cursor-pointer ${genStyles.tabBtn} ${showResultForm ? genStyles.tabBtnActive : genStyles.tabBtnInactive}`}>
                    <i className={`fa-solid fa-table ${genStyles.icomargin}`}></i>
                    RESULTAT
                </a>
              }
            </div>
          </div>
          }

          {!showResultForm && 
            <GeocoderInterface 
              api_collection={api_collection} 
              api_pci={api_pci} 
              ban_uri={ban_uri} 
              user_data={user_data} 
              fileTypesLinks={fileTypesLinks}
              iddCollectionSelected={iddCollectionSelected}
            />
           }
          {showResultForm && 
            <GeocoderResult onValidateEntite={onValidateEntite} onReloaEntite={onReloaEntite} />
          } 
          {loading && 
            <LoadingForm containerId={containerId} />
          }
        </div>
    );
}
